export const sports = [ "basketball", "boxe", "crossfit", "danse", "football",  "handball", "musculation", "Pilate", "Yoga", "zoumba"]